import React from 'react';
import { Stack, Skeleton } from '@mui/material';

export const OpportunitiesListFallback = () => {
  return (
    <Stack gap="1rem">
      <Skeleton sx={{ height: '150px' }} variant="rectangular" />
      <Skeleton sx={{ height: '150px' }} variant="rectangular" />
      <Skeleton sx={{ height: '150px' }} variant="rectangular" />
    </Stack>
  );
};
